<template>
  <div class="widget-sources">
  <!-- <pre>{{ showPopover }}</pre> -->
  <!-- <pre>ACTIVE POPOVER: {{ activePopover }}</pre> -->
  <!-- <pre>{{ buttons.map(button => (button.source && button.source.validators) ? button.source.validators : null) }}</pre> -->

    
    <div
      v-if="schema.subtitle"
      class="subtitle flex flex-align-center mt-0">
      <svg
        v-if="schema.subtitlePrefixIcon && typeof schema.subtitlePrefixIcon === 'string' && schema.subtitlePrefixIcon.endsWith('.svg')"
        class="mr-1 flex-start-image"
        :data-src="schema.subtitlePrefixIcon"
        fill="currentColor"
        width="10"
        height="10" />
      <img
        v-else-if="schema.subtitlePrefixIcon && typeof schema.subtitlePrefixIcon === 'string'"
        :src="schema.subtitlePrefixIcon"
        style="width: 8px; height: 8px;"
        class="mr-1 flex-start-image"
      >
      <SBIcon
        v-else-if="!schema.noSubtitlePrefixIcon"
        class="mr-1"
        :icon="SBIconList.INFO"
        :color="SBColors.greyLight"
        :size="10" />
      <span>{{ schema.subtitle }}</span>
    </div>
    <div
      v-for="(button, index) in buttons"
      :key="index"
      class="button-fields mb-2 relative"
      :class="{ 'hover-buttons-spacer': hoverDeleteButtons }" >
      
      <ValidationObserver
        ref="sourcesObserver"
        v-slot="{}" >
        <b-form-group>
          <div class="option flex align-start gap-10">
            <ValidationProvider
              v-slot="{ errors, failedRules }"
              class="w-100"
              :name="`Contact`"
              :rules="button.source && button.source.validators ? button.source.validators : ''"
              immediate >
              <input
                :id="`buttonInput-${index}`"
                :ref="`buttonInputRef-${index}`"
                v-model="button.number"
                :maxlength="schema.maxTextPreventInput ? buttonMaxTextLength : null"
                type="text"
                class="w-100 sb2-bordered option-item mb-0"
                :class="{ 'sb2-active sb2-hoverable sb2-focusable': !button.readOnly, empty: !button.value }"
                :placeholder="placeholders[index]"
                :readonly="button.readOnly"
                autocomplete="off"
                @blur="blurInput(index)"
                @focus="focusInput(index)"
                @input="inputHandler($event, index)" >
                <!--
                  @keydown="keydownHandler"
                  @paste="pasteHandler"
                -->
              <div
                v-if="errors[0]"
                class="error flex"
                :class="['flex-align-center']">
                <SBIcon
                  class="mr-1"
                  :icon="SBIconList.ERROR"
                  :color="SBColors.redPrimary"
                  :size="10" />
                <span>{{ errors[0] }}</span>
              </div>
              <b-popover
                :ref="`buttonInputPopoverRef-${index}`"
                :target="`buttonInput-${index}`"
                :custom-class="`select-popover w-${numberInputWidth}`"
                triggers=""
                placement="bottom"
                no-fade
                :show.sync="showPopover[index]"
                boundary="viewport"
                :boundary-padding="10"
                @shown="popoverShown(index)" >
                <div>
                  <div
                    v-for="(suggestion, i) in suggestions"
                    :key="`suggestion-${i}`"
                    class="suggestion-item"
                    :class="{ 'selected': i === popoverSelection }"
                    @mousedown.prevent="selectSuggestion(suggestion)"
                    @mouseenter="popoverSelection = i" >
                    {{ suggestion }}
                  </div>
                </div>
              </b-popover>
            </ValidationProvider>
            
            <ValidationProvider
              v-slot="{ errors, failedRules }"
              class="w-100"
              :name="`Title`"
              :rules="'required'" >
              <input
                :id="`buttonTitle-${index}`"
                :ref="`buttonTitleRef-${index}`"
                v-model="button.location"
                :maxlength="schema.maxTextPreventInput ? buttonMaxTextLength : null"
                type="text"
                class="w-100 sb2-bordered option-item mb-0"
                :class="{ 'sb2-active sb2-hoverable sb2-focusable': !button.readOnly, empty: !button.value }"
                placeholder="Title">
              <div
                v-if="errors[0]"
                class="error flex"
                :class="['flex-align-center']">
                <SBIcon
                  class="mr-1"
                  :icon="SBIconList.ERROR"
                  :color="SBColors.redPrimary"
                  :size="10" />
                <span>{{ errors[0] }}</span>
              </div>
            </ValidationProvider>

            <multiselect
              :ref="`sourceInputRef-${index}`"
              v-model="button.source"
              :placeholder="schema && schema.placeholder ? schema.placeholder : 'Select'"
              class="flex-options hide-tags no-selected-background"
              :options="schema.sourcesOptions"
              label="label"
              track-by="value"
              :multiple="false"
              :show-labels="false"
              :show-no-results="false"
              :close-on-select="true"
              :clear-on-select="false"
              :preserve-search="true"
              :allow-empty="false"
              :preselect-first="true"
              :searchable="false" >
              <template
                slot="selection"
                slot-scope="{ values }">
                <span
                  v-if="values.length"
                  class="multiselect__single" >{{ values }}</span>
              </template>
              <template
                slot="singleLabel"
                slot-scope="value">
                <span
                  v-if="true"
                  class="multiselect__single"
                  :class="{ 'image': value.option.image }"
                  :style="{ backgroundImage: `url(${value.option.image})` }" >{{ value.option.label }}</span>
              </template>
              <template
                slot="option"
                slot-scope="props">
                <span
                  class="greedy"
                  :class="{ 'image': props.option.image }"
                  :style="{ backgroundImage: `url(${props.option.image})` }" >{{ props.option.label }}</span>
                <SBIcon
                  :icon="SBIconList.DONE_CIRCLE"
                  :color="SBColors.bluePrimary"
                  :size="13"/>
              </template>
            </multiselect>

            <SBIcon
              v-if="!hoverDeleteButtons && buttons.length > schema.minButtons"
              class="delete-button trash"
              :icon="SBIconList.CLOSE_THIN"
              :color="SBColors.blackUltralight"
              :size="10"
              :pointer="true"
              :border-radius="30"
              :hover-icon-color="SBColors.blackPrimary"
              @click.native.stop
              @click="deleteItem(index)" />
          </div>
        </b-form-group>
        
        <!-- SB NOTE - GROUP ERRORS - add errors to the observer slot if this will be needed -->
        <!-- <div
          v-if="Object.values(errors).flat(Infinity).length > 0"
          class="error flex"
          :class="['flex-align-center']">
          <SBIcon
            class="mr-1"
            :icon="SBIconList.ERROR"
            :color="SBColors.redPrimary"
            :size="10" />
          <span>{{ Object.values(errors).flat(Infinity)[0] }}</span>
        </div> -->
      </ValidationObserver>

      <div
        v-if="button.subtitle"
        class="subtitle flex flex-align-center mb-0">
        <img
          v-if="button.subtitlePrefixIcon && typeof button.subtitlePrefixIcon === 'string'"
          :src="schema.subtitlePrefixIcon"
          style="width: 10px; height: 10px;"
          class="mr-1"
        >
        <SBIcon
          v-else-if="button.subtitlePrefixIcon"
          class="mr-1"
          :icon="button.subtitlePrefixIcon"
          :color="SBColors.greyLight"
          :size="10" />
        <span>{{ button.subtitle }}</span>
      </div>
      <SBIcon
        v-if="hoverDeleteButtons && buttons.length > schema.minButtons"
        class="delete-button on-parent-hover trash"
        :icon="SBIconList.TRASH"
        :color="SBColors.blackUltralight"
        :size="12"
        :hover-size="22"
        :pointer="true"
        :border-radius="30"
        :hover-icon-color="SBColors.redPrimary"
        @click.native.stop
        @click="deleteItem(index)" />
    </div>
    <span
      v-if="!schema.noAddButton && schema.maxButtons && buttons.length < schema.maxButtons"
      class="add-more-btn"
      :class="{
        disabled: !valid,
        black: schema.blackButtons,
      }"
      @click="addNewButtons">
      <span class="flex flex-align-center">
        <svg
          v-if="schema.addButtonIcon && typeof schema.addButtonIcon === 'string' && schema.addButtonIcon.endsWith('.svg')"
          class="mr-1 flex-start-image"
          :data-src="schema.addButtonIcon"
          fill="currentColor"
          width="10"
          height="10" />
        <img
          v-else-if="schema.addButtonIcon && typeof schema.addButtonIcon === 'string'"
          :src="schema.addButtonIcon"
          style="width: 8px; height: 8px;"
          class="mr-1"
        >
        <SBIcon
          v-else-if="!schema.noSubtitlePrefixIcon"
          class="mr-2"
          :icon="SBIconList.PLUS"
          :color="schema.blackButtons ? SBColors.blackPrimary : SBColors.bluePrimary"
          :size="8" />
        <span>{{ schema.addButtonText || 'Add' }}</span>
      </span>
    </span>
    <!-- <pre>{{  buttons }}</pre> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';

import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import { scrollIntoViewIfNeeded } from '@/helpers/scrollHelpers';

export default {
  name: 'WidgetSources',
  components: {
    SBIcon,
    Multiselect,
  },
  props: {
    validators: {
      type: String,
      default: '',
    },
    schema: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      SBIconList,
      SBColors,
      valid: true,
      showPopover: {},
      activePopover: null,
      popoverSelection: null,
      numberInputWidth: 0,
      buttons: [],
    };
  },
  computed: {
    ...mapGetters({
      currentOrganisationBusinesses: 'organisation/currentOrganisationBusinesses',
    }),
    availableNumbers() {
      return this.currentOrganisationBusinesses.map(business => this.$options.filters.phoneFormat(business.phone));
    },
    hoverDeleteButtons() {
      return !(this.schema.hoverDeleteButtons === false);
    },
    placeholders() {
      return this.buttons.map((button) => {
        // SB NOTE: This is a non-breaking space character. It helps prevent the browser autosuggesting the email address. Browsers ignore the autocomplete attribute for "important" fields such as email if they figure out the placeholder is an email for example even if the autocomplete attribute is set to off and input type is text.
        const zeroWidthNbsp = '\u2060';
        switch (button.source && button.source.value) {
          case 'whatsapp':
          case 'call':
          case 'text':
            return '+44 1632 960643';
          case 'messenger':
            return 'm.me/page-name';
          case 'email':
            return `info@${zeroWidthNbsp}example.com`;
          default:
            return '';
        }
      });
    },
    proccessedValidators() {
      return this.schema.validators ? this.schema.validators.replace('uniques', `uniques:${this.buttons.map(button => button.value)}`) : 'required';
    },
    suggestions() {
      // console.log('\n SUGGESTIONSSSSSSS');
      // const activePopover = Object.keys(this.showPopover).find(key => this.showPopover[key]);
      // console.log('activePopover', activePopover);
      // return ['123', '456', '789', '101', '202', '303', '404', '505', '606', '707', '808', '909', '1010'];
      if (this.activePopover === null || !['whatsapp', 'call', 'text'].includes(this.buttons[this.activePopover].source.value)) return [];
      // console.log('activePopover', this.activePopover);
      // console.log('buttons[this.activePopover]', this.buttons[this.activePopover]);
      const currentValue = this.buttons[this.activePopover].number ? this.buttons[this.activePopover].number.toString().replace(/\s/g, '') : '';
      // console.log('currentValue', currentValue);
      // console.log('----------- availableNumbers', this.availableNumbers);
      // console.log(`this.availableNumbers.filter(number => number.toString().replace(/\s/g, '').includes(currentValue))`, this.availableNumbers.filter(number => number.toString().replace(/\s/g, '').includes(currentValue)).filter(number => number.toString().replace(/\s/g, '') !== currentValue.toString().replace(/\s/g, '')));
      return this.availableNumbers.filter(number => number.toString().replace(/\s/g, '').includes(currentValue)).filter(number => number.toString().replace(/\s/g, '') !== currentValue.toString().replace(/\s/g, ''));
    },
    warningValidators() {
      return this.schema.warningValidators ? this.schema.warningValidators.split(',') : [];
    },
  },
  watch: {
    buttons: {
      handler(newVal, oldVal) {
        this.$nextTick(() => {
          if (this.$refs['buttonInputRef-0'] && this.$refs['buttonInputRef-0'][0]) {
            this.numberInputWidth = this.$refs['buttonInputRef-0'][0].offsetWidth;
          }
          this.emitData();
        });
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    if (this.schema.value && this.schema.value.length > 0) {
      this.buttons = JSON.parse(JSON.stringify(this.schema.value));
    } else if (this.schema.minButtons) {
      for (let i = 0; i < this.schema.minButtons; i++) {
        this.buttons.push({ number: null, location: this.schema.defaultLocation || null, source: null });
      }
    }
    setTimeout(() => {
      this.emitData(true);
      if (this.$refs && this.$refs.sourcesObserver && this.$refs.sourcesObserver.length > 0) {
        this.$refs.sourcesObserver.forEach((observer, index) => {
          observer.reset();
        });
      }
    }, 0);
    document.addEventListener('keydown', this.handleKeyDown);
    this.buttons.forEach((button) => {
      if (button.source && typeof button.source === 'string') {
        button.source = this.schema.sourcesOptions.find(option => option.value === button.source);
      }
    });
    this.buttons = [...this.buttons];
  },
  destroyed() {
    document.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    addNewButtons() {
      this.buttons.push({ number: null, location: this.schema.defaultLocation || null, source: null });
      this.buttons = [...this.buttons];
    },
    contactNumberPopoverIsNeeded(index) {
      // console.log('contactNumberPopoverIsNeeded', index);
      // console.log('buttons[index].number', this.buttons[index].number);
      // console.log('availableNumbers', this.availableNumbers);
      return this.suggestions.length > 0;
    },
    focusInput(index) {
      // console.log('focusInput', index);
      this.activePopover = index;
      if (!this.contactNumberPopoverIsNeeded(index)) {
        this.$set(this.showPopover, index, false);
      } else {
        this.$set(this.showPopover, index, true);
      }
    },
    blurInput(index) {
      this.$set(this.showPopover, index, false);
      this.activePopover = null;
    },
    inputHandler(event, index) {
      this.activePopover = index;
      if (!this.contactNumberPopoverIsNeeded(index)) {
        this.$set(this.showPopover, index, false);
      } else {
        this.$set(this.showPopover, index, true);
      }
    },
    popoverSelectionHandler(event, direction) {
      // console.log('popoverSelectionHandler', event, direction);
      if (!this.popoverSelection && this.popoverSelection !== 0) {
        if (direction === -1) {
          this.popoverSelection = this.suggestions.length - 1;
        } else {
          this.popoverSelection = 0;
        }
      } else {
        this.popoverSelection = this.popoverSelection + direction;
      }
      if (this.popoverSelection < 0) {
        this.popoverSelection = this.suggestions.length - 1;
      } else if (this.popoverSelection >= this.suggestions.length) {
        this.popoverSelection = 0;
      }
      setTimeout(() => {
        const element = this.$refs[`buttonInputPopoverRef-${this.activePopover}`][0].$_toolpop.getTemplateElement().querySelector('.suggestion-item.selected');
        // console.log('>>>>>>> element', element);
        // element.scrollIntoView();
        if (element) {
          // console.log('\n\n\n SCROLLLLLLLL');
          scrollIntoViewIfNeeded(this.$refs[`buttonInputPopoverRef-${this.activePopover}`][0].$_toolpop.getTemplateElement(), element);
        }
      }, 0);
    },
    handleKeyDown(event) {
      switch (event.key) {
        case 'ArrowUp':
          this.popoverSelectionHandler(event, -1);
          break;
        case 'ArrowDown':
          this.popoverSelectionHandler(event, 1);
          break;
        case 'Enter':
          this.selectSuggestion(this.suggestions[this.popoverSelection]);
          break;
        default:
          break;
      }
    },
    selectSuggestion(suggestion) {
      // console.log('selectSuggestion', suggestion);
      this.buttons[this.activePopover].number = suggestion;
      this.buttons = [...this.buttons];
      this.inputHandler(null, this.activePopover);
      this.blurInput(this.activePopover);
      this.popoverSelection = null;
    },
    popoverShown(index) {
      // console.log('*********** popoverShown', index);
      // console.log('element 333333', this.$refs[`buttonInputPopoverRef-${this.activePopover}`]);
    },
    deleteItem(index) {
      // console.log('deleteItem', index);
      this.buttons = this.buttons.filter((button, i) => i !== index);
      this.buttons = [...this.buttons];
    },

    emitData(reset = false) {
      if (!this.$refs.sourcesObserver || !this.$refs.sourcesObserver.length === 0) return;

      let valid = true;
      const promises = [];
      this.$refs.sourcesObserver.forEach((observer, index) => {
        promises.push(observer.validate({ silent: true })
          .then((v) => {
            if (!v) {
              valid = false;
            }
          })
          .finally(() => {
            //   if (reset) this.$refs.buttonsObserver.reset();
          }));
      });
      Promise.all(promises).then(() => {
        this.valid = valid;
        this.$emit('input', {
          valid,
          name: this.schema.returnKey || '',
          data: {
            value: this.buttons.map(button => ({
              number: button.number,
              location: button.location,
              source: button.source.value,
            })),
          },
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.widget-sources {
  .button-fields {
    // To make space for the delete button which appears only on hover
    &.hover-buttons-spacer {
      margin-right: -30px;
      padding-right: 30px;
    }

    .delete-button.on-parent-hover {
      display: none;
      position: absolute;
      right: 2px;
      top: 5px;
      box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.1);
      border: solid 1px $greyBorder;
    }

    .delete-button {
      top: 11px;
    }

    &:hover .sb-icon.on-parent-hover {
      display: flex;

      &:hover {
        box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.3);
      }
    }
  }

  .add-more-btn {
    display: block;
    width: fit-content;
    color: $bluePrimary;
    padding: 0 0 0 0;
    // margin-top: 15px;

    &.black:not(.disabled) {
      color: $blackPrimary;
    }

    span {
      font-weight: 500;
      font-size: 14px;
    }

    &:hover {
      cursor: pointer;
      color: $blackPrimary;
      ::v-deep .sb-icon .mask {
        background-color: $blackPrimary !important;
      }
    }

    &.disabled {
      pointer-events: none;
      color: $greyLight !important;

      ::v-deep .icon.mask {
        background-color: $greyLight !important;
      }
    }
  }

  ::v-deep .multiselect__tags > .multiselect__single {
    top: 1px;
  }
}
</style>
